<span>
  <span matPrefix [innerHtml]="data?.currency.symbol"></span>
  <span>{{ formatted }}</span>
</span>
